import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader.tsx";
import { lazy, Suspense } from "react";

const BloodOxygenHistoryPage = lazy(
  () => import("./BloodOxygenHistoryPage.tsx"),
);

function BloodOxygenHistoryPageLazy() {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BloodOxygenHistoryPage />
    </Suspense>
  );
}

export default BloodOxygenHistoryPageLazy;
